import type React from 'react';

import { observer } from 'mobx-react';

import withDisplayName from 'bz-utilities/hoc/display-name';

import { cache } from 'tm3-core/cache';
import type { IsProduct } from 'tm3-core/enums/product-enum';

interface IProps extends React.PropsWithChildren {
  product?: IsProduct;
  products?: IsProduct[];
}
const ShowFor = observer(
  withDisplayName<IProps>(({ product, products, children }) => {
    if (product != null && cache.checkLicence(product)) return children;
    if (products?.some((p) => cache.checkLicence(p))) return children;
    return null;
  }, 'ShowFor')
);

export default ShowFor;
